import { ProductOptions } from "./ProductOptions";

export const ProductSubMenus = {
  [ProductOptions.Settings]: ["Apikey", "ServiceAccount"],
  [ProductOptions.Gateway]: ["Receipt"],
}